import type { TabModel } from '../model/types';

/**
 * Ekran kaydı OLMAYAN nesnenin sekmesi (#533).
 *
 * Sekmeler menüdeki ekrana bağlıydı: nesnenin `Tb_Rn_Sys_Screens` kaydı yoksa popup'taki
 * "yeni sekmede aç" düğmesi hiç çıkmıyordu. Oysa SP parametre formu, detay sekmeleri ve
 * sonuç popup'ı nesneyi ekransız, yalnız ObjectId ile açıyor; yetki de nesne üzerinden
 * (`Tb_Rn_Sys_RoleObjects`). Bu sekme aynı yolu kullanır: nesne paketi + popup'ın filtresi.
 */
export const OBJECT_TAB_TYPE = 'objectgrid';

export interface ObjectTabFilter {
  whereClause?: string | null;
  hedefFilter?: string | null;
  hedefFilterValue?: unknown;
}

export interface ObjectTabParams extends ObjectTabFilter {
  objectId: string;
  /** SP @MaxRecords çıktısı → TOP N (popup'taki gibi). */
  maxRecords?: number | null;
}

/**
 * `openCustom` için sekme tanımı. Her çağrı AYRI sekme açar (#445'teki kararla aynı):
 * aynı nesne farklı filtreyle tekrar açıldığında eski sekmeye odaklanmak "hiçbir şey
 * olmadı" gibi görünürdü ve filtre o sekmeye taşınamazdı.
 */
export function objectTabSpec(
  objectId: string,
  caption: string,
  filter: ObjectTabFilter = {},
  opts: { maxRecords?: number | null } = {},
): Omit<TabModel, 'tabId' | 'createdAt' | 'lastActiveAt'> {
  const params: Record<string, unknown> = { objectId };
  if (filter.whereClause) params['whereClause'] = filter.whereClause;
  if (filter.hedefFilter) {
    params['hedefFilter'] = filter.hedefFilter;
    params['hedefFilterValue'] = filter.hedefFilterValue;
  }
  if (opts.maxRecords) params['maxRecords'] = opts.maxRecords;
  return {
    kind: 'custom',
    screenTypeName: OBJECT_TAB_TYPE,
    objectId,
    caption,
    params,
    uniqueKey: `${OBJECT_TAB_TYPE}:${objectId.toLowerCase()}#${crypto.randomUUID()}`,
  };
}

/** Sekme parametrelerini geri okur; sayfa yenilenince sessionStorage'dan gelenler de aynı biçimde. */
export function objectTabParams(tab: Pick<TabModel, 'params' | 'objectId'>): ObjectTabParams {
  const p = tab.params;
  const objectId = typeof p['objectId'] === 'string' && p['objectId'] ? p['objectId'] : (tab.objectId ?? '');
  const hedefFilter = typeof p['hedefFilter'] === 'string' && p['hedefFilter'] ? p['hedefFilter'] : null;
  const maxRecords = typeof p['maxRecords'] === 'number' && p['maxRecords'] > 0 ? p['maxRecords'] : null;
  return {
    objectId,
    whereClause: typeof p['whereClause'] === 'string' && p['whereClause'] ? p['whereClause'] : null,
    hedefFilter,
    hedefFilterValue: hedefFilter ? p['hedefFilterValue'] : undefined,
    maxRecords,
  };
}
